var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpowermentColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "002-empowerment",
    clipPath: "url(#clip0_472_196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.0406 48.3251C19.6984 47.9375 19.1068 47.9005 18.7189 48.2428C18.3314 48.585 18.2945 49.1766 18.6367 49.5644L21.6605 52.9898V62.8289C21.6605 63.346 22.0796 63.7652 22.5968 63.7652C23.114 63.7652 23.5331 63.346 23.5331 62.8289V52.6356C23.5331 52.4074 23.4497 52.1871 23.2987 52.0161L20.0406 48.3251Z",
    fill: "url(#paint0_linear_472_196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.4314 40.838C10.8205 37.8803 10.2406 33.6729 11.954 30.1194L13.219 27.4958C13.4436 27.03 13.248 26.4704 12.7822 26.2458C12.3167 26.0212 11.7568 26.2167 11.5322 26.6826L10.2672 29.3062C8.22574 33.5403 8.91672 38.5533 12.0274 42.0773L15.9396 46.5093C16.1246 46.7189 16.3826 46.8261 16.6419 46.8261C16.8622 46.8261 17.0831 46.7488 17.2611 46.5917C17.6488 46.2496 17.6857 45.6579 17.3435 45.2702L13.4314 40.838Z",
    fill: "url(#paint1_linear_472_196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M44.7423 15.0053C43.5376 15.0053 42.4433 15.4836 41.6367 16.2591C40.8927 14.8104 39.3831 13.8167 37.6455 13.8167C36.416 13.8167 35.3017 14.3153 34.4909 15.1195C33.7312 13.7206 32.2493 12.7685 30.5485 12.7685C29.3237 12.7685 28.2124 13.2625 27.4022 14.0612C26.6443 12.6549 25.1579 11.6968 23.4515 11.6968C20.9786 11.6968 18.9668 13.7087 18.9668 16.1816V20.1061C16.8212 20.0179 14.7046 21.0189 13.426 22.9125C13.1367 23.3411 13.2495 23.9231 13.678 24.2124C14.1066 24.5016 14.6885 24.3889 14.978 23.9604C16.2767 22.0369 18.8013 21.4157 20.8493 22.5154L32.0859 28.5475C32.6555 28.8534 33.0172 29.445 33.0295 30.0917C33.0425 30.7664 32.6812 31.3842 32.0866 31.7038L30.6127 32.4963C28.5191 33.6217 25.9997 33.6604 23.8727 32.6L20.4662 30.9017C20.0032 30.6709 19.4413 30.8593 19.2105 31.3219C18.9797 31.7847 19.1678 32.3469 19.6306 32.5776L23.037 34.2759C24.329 34.92 25.7356 35.241 27.1419 35.241C28.6426 35.241 30.1424 34.8751 31.4993 34.1458L31.6116 34.0854L33.4791 36.3334C34.3326 37.3607 34.8026 38.662 34.8026 39.9978V45.3894C34.8026 45.9065 35.2217 46.3257 35.7389 46.3257C36.2561 46.3257 36.6752 45.9065 36.6752 45.3894V39.9978C36.6752 38.226 36.0516 36.4996 34.9196 35.1369L33.2818 33.1653C34.3121 32.4748 34.9259 31.3148 34.9017 30.0562C34.8916 29.5294 34.7665 29.0212 34.5481 28.5598C35.3535 29.3312 36.4446 29.8063 37.6454 29.8063C38.8912 29.8063 40.0183 29.2945 40.8316 28.4715C41.6009 29.8386 43.0651 30.7647 44.7423 30.7647C45.4563 30.7647 46.1311 30.5961 46.731 30.2981V32.5305C46.731 33.0476 47.1501 33.4668 47.6673 33.4668C48.1845 33.4668 48.6035 33.0476 48.6035 32.5305V28.5574C48.999 27.8894 49.2271 27.1109 49.2271 26.2799V19.4903C49.2271 17.0171 47.2151 15.0053 44.7423 15.0053ZM20.8394 20.4694V16.1816C20.8394 14.7412 22.0112 13.5694 23.4515 13.5694C24.8918 13.5694 26.0637 14.7412 26.0637 16.1816V23.1891L21.7352 20.8654C21.4427 20.7085 21.1431 20.5775 20.8394 20.4694ZM27.9363 24.1945V17.2535C27.9363 15.8131 29.1081 14.6412 30.5485 14.6412C31.9889 14.6412 33.1607 15.8131 33.1607 17.2535V25.3212C33.1607 25.8388 33.0058 26.3403 32.7242 26.7647L27.9363 24.1945ZM37.6454 27.9335C36.205 27.9335 35.0332 26.7616 35.0332 25.3212V18.3015C35.0332 16.8611 36.205 15.6894 37.6454 15.6894C39.0857 15.6894 40.2575 16.8612 40.2575 18.3015V25.3212C40.2575 26.7616 39.0857 27.9335 37.6454 27.9335ZM44.7423 28.8918C43.3019 28.8918 42.1301 27.72 42.1301 26.2796V19.4901C42.1301 18.0497 43.3019 16.878 44.7423 16.878C46.1827 16.878 47.3545 18.0498 47.3545 19.4901V26.2796C47.3545 27.72 46.1827 28.8918 44.7423 28.8918Z",
    fill: "url(#paint2_linear_472_196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M47.6672 35.584C47.1499 35.584 46.7309 36.0032 46.7309 36.5203V45.0057C46.7309 46.4103 46.3557 47.7935 45.6459 49.0057L44.2269 51.4296C44.0196 51.7834 43.9102 52.1871 43.9102 52.5973V62.8289C43.9102 63.346 44.3292 63.7652 44.8464 63.7652C45.3636 63.7652 45.7827 63.346 45.7827 62.8289V52.5973C45.7827 52.5195 45.8034 52.443 45.8428 52.3758L47.2618 49.952C48.1395 48.4531 48.6034 46.7426 48.6034 45.0058V36.5204C48.6034 36.0032 48.1844 35.584 47.6672 35.584Z",
    fill: "url(#paint3_linear_472_196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M42.4922 9.21264C42.649 9.31351 42.8244 9.36169 42.9981 9.36169C43.3058 9.36169 43.6074 9.21002 43.7862 8.932L48.4543 1.67792C48.7342 1.24311 48.6085 0.663742 48.1737 0.383856C47.739 0.104094 47.1595 0.229556 46.8798 0.664616L42.2116 7.91869C41.9317 8.3535 42.0574 8.93275 42.4922 9.21264Z",
    fill: "url(#paint4_linear_472_196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M52.1065 15.4896C52.2779 15.6241 52.4815 15.6893 52.6838 15.6893C52.9615 15.6893 53.2364 15.5663 53.4211 15.3308L63.8001 2.09937C64.1193 1.69252 64.048 1.10391 63.6413 0.784828C63.2346 0.465742 62.6458 0.536775 62.3267 0.943621L51.9477 14.1751C51.6285 14.582 51.6997 15.1705 52.1065 15.4896Z",
    fill: "url(#paint5_linear_472_196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M62.6084 24.8364L58.4437 27.1524C57.9919 27.4037 57.8293 27.9738 58.0806 28.4257C58.2517 28.7335 58.5708 28.9071 58.8998 28.9071C59.0537 28.9071 59.2099 28.869 59.354 28.7889L63.5188 26.4729C63.9705 26.2216 64.1332 25.6514 63.8819 25.1995C63.6305 24.7476 63.0604 24.5849 62.6084 24.8364Z",
    fill: "url(#paint6_linear_472_196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M63.4208 42.1192L59.3826 39.6823C58.9402 39.4153 58.3645 39.5574 58.0972 40.0002C57.83 40.4428 57.9723 41.0184 58.4151 41.2855L62.4533 43.7223C62.6046 43.8136 62.7714 43.8572 62.9361 43.8572C63.2534 43.8572 63.5628 43.6959 63.7387 43.4045C64.0058 42.9618 63.8636 42.3863 63.4208 42.1192Z",
    fill: "url(#paint7_linear_472_196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M52.2306 48.3001C51.895 47.9071 51.304 47.8606 50.9106 48.1965C50.5175 48.5325 50.4711 49.1234 50.807 49.5165L52.3079 51.2731C52.4931 51.4899 52.7558 51.6012 53.0202 51.6012C53.2353 51.6012 53.4516 51.5274 53.628 51.3768C54.0211 51.0408 54.0675 50.4498 53.7316 50.0567L52.2306 48.3001Z",
    fill: "url(#paint8_linear_472_196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M56.403 53.1832C56.0673 52.7902 55.4763 52.7436 55.083 53.0795C54.6899 53.4155 54.6434 54.0065 54.9794 54.3996L60.2061 60.5168C60.3912 60.7335 60.654 60.8448 60.9184 60.8448C61.1335 60.8448 61.3497 60.771 61.5261 60.6204C61.9192 60.2844 61.9657 59.6935 61.6297 59.3003L56.403 53.1832Z",
    fill: "url(#paint9_linear_472_196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M35.2837 6.71002C35.3817 6.74261 35.4813 6.75809 35.5792 6.75809C35.9716 6.75809 36.337 6.50954 36.4676 6.11692L37.5011 3.00771C37.6643 2.51697 37.3987 1.98703 36.908 1.82387C36.417 1.66083 35.8872 1.92636 35.7241 2.41698L34.6906 5.52619C34.5276 6.01692 34.793 6.54686 35.2837 6.71002Z",
    fill: "url(#paint10_linear_472_196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M20.2136 8.93188C20.3926 9.21002 20.694 9.36158 21.0017 9.36158C21.1753 9.36158 21.3508 9.31339 21.5076 9.21252C21.9424 8.93263 22.0681 8.35339 21.7882 7.91845L17.1201 0.664499C16.8404 0.229688 16.261 0.104101 15.8262 0.383738C15.3914 0.663625 15.2657 1.24287 15.5456 1.67781L20.2136 8.93188Z",
    fill: "url(#paint11_linear_472_196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M10.8325 15.3359C11.0173 15.5683 11.2901 15.6893 11.5657 15.6893C11.77 15.6893 11.9758 15.6227 12.148 15.4856C12.5526 15.1637 12.6197 14.5745 12.2976 14.1699L1.66902 0.813665C1.34706 0.409066 0.758078 0.342028 0.353353 0.663985C-0.0513709 0.985941 -0.118284 1.57505 0.203798 1.97965L10.8325 15.3359Z",
    fill: "url(#paint12_linear_472_196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M4.91585 28.7997C5.05467 28.8725 5.20348 28.9071 5.35004 28.9071C5.68698 28.9071 6.01268 28.7247 6.17996 28.4056C6.42015 27.9477 6.24376 27.3817 5.78585 27.1415L1.37146 24.8255C0.913678 24.5853 0.347663 24.7617 0.10735 25.2196C-0.132838 25.6775 0.0435579 26.2435 0.501463 26.4837L4.91585 28.7997Z",
    fill: "url(#paint13_linear_472_196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M6.15279 40.0003C5.88551 39.5576 5.31014 39.4153 4.86734 39.6825L0.829206 42.1193C0.386406 42.3864 0.244091 42.9619 0.511244 43.4046C0.687141 43.696 0.996614 43.8573 1.31383 43.8573C1.47849 43.8573 1.6454 43.8138 1.7967 43.7225L5.83483 41.2856C6.27763 41.0185 6.41982 40.443 6.15279 40.0003Z",
    fill: "url(#paint14_linear_472_196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M13.3388 48.1965C12.9457 47.8606 12.3546 47.907 12.0188 48.3001L10.5179 50.0567C10.1821 50.4498 10.2284 51.0408 10.6215 51.3768C10.7979 51.5274 11.0141 51.6012 11.2292 51.6012C11.4936 51.6012 11.7564 51.4899 11.9415 51.2732L13.4425 49.5166C13.7784 49.1234 13.732 48.5325 13.3388 48.1965Z",
    fill: "url(#paint15_linear_472_196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M9.16668 53.0796C8.77344 52.7435 8.18233 52.7902 7.84665 53.1832L2.61993 59.3004C2.28412 59.6935 2.33044 60.2845 2.72355 60.6204C2.89995 60.7712 3.11617 60.8448 3.33126 60.8448C3.59567 60.8448 3.85845 60.7335 4.04359 60.5168L9.2703 54.3996C9.60624 54.0064 9.55992 53.4155 9.16668 53.0796Z",
    fill: "url(#paint16_linear_472_196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M27.5323 6.1169C27.6629 6.50964 28.0284 6.75807 28.4206 6.75807C28.5185 6.75807 28.6181 6.74259 28.7161 6.71001C29.2069 6.54684 29.4724 6.01691 29.3092 5.52617L28.2757 2.41696C28.1124 1.92622 27.5825 1.66081 27.0919 1.82385C26.6011 1.98702 26.3356 2.51695 26.4988 3.00769L27.5323 6.1169Z",
    fill: "url(#paint17_linear_472_196)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_472_196",
    x1: 18.7415,
    y1: 49.8997,
    x2: 29.5034,
    y2: 56.7575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_472_196",
    x1: 9.66641,
    y1: 28.634,
    x2: 24.8724,
    y2: 40.8279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_472_196",
    x1: 15.6427,
    y1: 15.8532,
    x2: 36.3165,
    y2: 57.8683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_472_196",
    x1: 44.2204,
    y1: 38.9665,
    x2: 56.7331,
    y2: 43.0446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_472_196",
    x1: 42.4949,
    y1: 1.33028,
    x2: 48.9967,
    y2: 10.4491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_472_196",
    x1: 52.5579,
    y1: 2.39812,
    x2: 62.8236,
    y2: 18.6939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_472_196",
    x1: 58.3615,
    y1: 25.2209,
    x2: 60.3497,
    y2: 30.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_472_196",
    x1: 58.3531,
    y1: 40.0648,
    x2: 60.4779,
    y2: 45.7681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_472_196",
    x1: 50.8055,
    y1: 48.4077,
    x2: 53.1144,
    y2: 52.6078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_472_196",
    x1: 55.2241,
    y1: 53.8141,
    x2: 60.4278,
    y2: 62.8626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_472_196",
    x1: 34.8347,
    y1: 2.37386,
    x2: 38.5563,
    y2: 6.62267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_472_196",
    x1: 15.8288,
    y1: 1.33027,
    x2: 22.3306,
    y2: 10.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_472_196",
    x1: 0.826342,
    y1: 2.28823,
    x2: 11.1232,
    y2: 18.8296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_472_196",
    x1: 0.415593,
    y1: 25.2209,
    x2: 2.3416,
    y2: 30.8782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_472_196",
    x1: 0.767187,
    y1: 40.0649,
    x2: 2.89195,
    y2: 45.7682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_472_196",
    x1: 10.5164,
    y1: 48.4076,
    x2: 12.8254,
    y2: 52.6078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_472_196",
    x1: 2.86477,
    y1: 53.8141,
    x2: 8.06845,
    y2: 62.8626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_472_196",
    x1: 26.6428,
    y1: 2.37383,
    x2: 30.3644,
    y2: 6.62271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0159153,
    stopColor: "#F4EE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#31A7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90A04"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_472_196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpowermentColor);
export default __webpack_public_path__ + "static/media/empowermentColor.1a20908766e1eebbee88c64f9dd84ce9.svg";
export { ForwardRef as ReactComponent };